/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Prompt_Body_OrganizerInputs */



/**
* | output |
* | --- |
* | "Turn on notifications for judge calls and announcements at this event." |
*
* @param {Notifications_Prompt_Body_OrganizerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_prompt_body_organizer = /** @type {((inputs?: Notifications_Prompt_Body_OrganizerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Prompt_Body_OrganizerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activez les notifications pour les appels à l’arbitre et les annonces de cet événement.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Active las notificaciones para las llamadas al juez y los anuncios de este evento.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ative as notificações para as chamadas de juiz e os anúncios deste evento.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva le notifiche per le chiamate al giudice e gli annunci di questo evento.")
	return /** @type {LocalizedString} */ ("Turn on notifications for judge calls and announcements at this event.")
});